export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJNzgtUktTSi1IYQWBQQG9Tw0BvVEJAr1TAgS9VgQRvVtBFYGBvW2CHQABAAEAAQABABkAHwABAAEABgBTAAEAAQABAAEAGQAgAAEAAQAGAGEBg5UBvgI=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/78-RKSJ-V.bcmap
// module id = 571
// module chunks = 502